module.exports = __webpack_public_path__ + "static/media/ai_worth_2.0edc8e71.png";